import { Box, Grid, Typography, ImageListItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useLocation, useParams } from "react-router-dom";
import { useCrudForm } from "../../../api/useCrudForm";
import { endpoints } from "../../../api/endpoints";
import { ProceedBtn } from "../../../components/styledComponent/Button";
import { Fingerprint } from "@mui/icons-material";
import { toast } from "react-toastify";
import useFingerControl from "../../../components/biometric/useFingerControl";
import ImageDisplay from "../../../components/biometric/ImageDisplay";
import { LeftFingerImage, RightFingerImage } from "../../../components/utility/ImgNIcons";

type BiometricsFormPropsType = {
    children: any,
    setPage: (value: any) => void,
    fetchData: any,
    isAttorney?: boolean
}
export type valuesTypes = {
    customerFinger: {}[]
}

const initialValues = {
    customerFinger: []
}

const BiometricsForm = ({ children, setPage, fetchData, isAttorney }: BiometricsFormPropsType) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const isMainTable = queryParams.get('isMainTable');
    const { handleSubmit, control, setValue } = useForm<valuesTypes>(
        {
            defaultValues: initialValues
        }
    )

    const { fields, append, update } = useFieldArray({
        control,
        name: "customerFinger"
    });

    const { id } = useParams()
    const [imageData, setImageData] = useState<Uint8Array | null>(null);
    const [message, setMessage] = useState('');
    const [lastInitOp, setLastInitOp] = useState(null);
    const { add, get } = useCrudForm()

    const fetchFingerData = async () => await get({
        endpoints: endpoints.customerFinger.api + `/${id}?isMainTable=${isMainTable ? isMainTable : false}`,
        onSuccess: (data: any) => {
            setValue('customerFinger', data.data)
        },
        onError: (error: any) => {
            console.log(error)
        }
    })

    useEffect(() => {
        if (id && id !== '') {
            fetchFingerData()
        }
    }, [id])


    const onSubmit = (values: any) => {

        const fingerData = values.customerFinger
        const isValid = () => fingerData.every((obj: any) => obj.fingerSample !== '' && obj.fingerSample !== undefined);

        if (isValid()) {
            add({
                endpoints: endpoints.customerFinger.api + `?isMainTable=${isMainTable ? isMainTable : false}`,
                onSuccess: (data: any) => {
                    if (!isAttorney) {
                        setPage('three')
                    } else {
                        setPage('one')
                    }
                    toast.success(data.message, { style: { background: '#3150A1' } })
                    fetchData()
                },
                onError: (error: any) => {
                    toast.error(error?.message ?? error)
                },
                values: fingerData
            })
        } else {
            toast.error('Please update both finger')
        }

    };



    return (
        <Box component="form" onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3}>
                <Fingerprints update={update} append={append} fields={fields} control={control} imageData={imageData} setImageData={setImageData} message={message} setMessage={setMessage} lastInitOp={lastInitOp} setLastInitOp={setLastInitOp} />
            </Grid>

            {children}
        </Box>
    );
}

const Fingerprints = ({ update, append, fields }: any) => {

    const { id } = useParams()

    const [state, setState] = useState<any>({

        fingerSample: '',
        fingerType: '',

    })

    const control = useFingerControl(setState)

    const handleClick = (fingerType: string) => {
        const image = fingerType === 'left' ? { left: undefined, right: state?.right } : { right: undefined, left: state?.left }
        setState((prev: any) => { return { ...prev, fingerType: fingerType, ...image } })
        control('enroll', 'ftrapi', 3)
    };

    const setBiometricData = (values: any) => {
        const idx = fields.findIndex((finger: any) => finger.fingerType! === values.fingerType)
        const fingerType = values.fingerType === 0 ? 'left' : 'right'
        const image = values.fingerType === 0 ? { right: state?.right } : { left: state?.left }
        const imagetype = values.fingerType === 0 ? 'right' : 'left'
        if (idx !== -1) {
            toast.success('Fingerprint captured successfully', { style: { background: '#3150A1' } })
            setState({ [fingerType]: values.fingerImage, [imagetype]: image?.left ?? image?.right })
            update(idx, values)
        } else {
            toast.success('Fingerprint captured successfully', { style: { background: '#3150A1' } })
            setState({ [fingerType]: values.fingerImage, [imagetype]: image?.left ?? image?.right })
            append(values)
        }
    }


    useEffect(() => {
        if (state?.fingerTemplate && state?.fingerImage) {
            const values = {
                customerId: Number(id),
                fingerImage: state?.fingerImage,
                fingerSample: state?.fingerTemplate,
                fingerType: state?.fingerType === 'left' ? 0 : 1,
            }
            setBiometricData(values)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state])


    const getSelectedBiometricData = (fingerType: any) => {
        const idx = fields.findIndex((finger: any) => finger.fingerType! === fingerType)
        if (idx !== -1) {
            return fields[idx]
        } else {
            return
        }
    }

    return (
        <>

            <Grid item xs={5}>
                <Typography sx={{ color: "black", fontSize: "20px", fontWeight: "700" }} mb={2}>
                    Fingerprints
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={6} >
                        <Typography sx={{ color: "black", fontSize: "14px", fontWeight: "400" }} mb={2}>
                            Left
                        </Typography>
                        {state.fingerType === 'left' || (state.left || getSelectedBiometricData(0)?.fingerImage) ? <ImageDisplay fingerImage={state.left ?? getSelectedBiometricData(0)?.fingerImage} setFingerImage={setState} imageData={state?.uint8Array} message={state?.message} fingerType={state.fingerType === 'left'} /> :
                            <ImageListItem>
                                <img style={{ objectFit: "cover", maxHeight: "300px", border: '2px solid green', borderRadius: '5px', filter: 'invert(1)' }} src={LeftFingerImage} alt="Left Finger" />
                            </ImageListItem>}
                        <ProceedBtn onClick={() => {
                            handleClick('left')
                        }}>
                            <Fingerprint />
                            <Typography sx={{ textTransform: "capitalize", fontSize: "14px" }}>Capture</Typography>
                        </ProceedBtn>
                    </Grid>
                    <Grid item xs={6} >
                        <Typography sx={{ color: "black", fontSize: "14px", fontWeight: "400" }} mb={2}>
                            Right
                        </Typography>

                        {state.fingerType === 'right' || (state.right || getSelectedBiometricData(1)?.fingerImage) ? <ImageDisplay fingerImage={state.right ?? getSelectedBiometricData(1)?.fingerImage} setFingerImage={setState} imageData={state?.uint8Array} message={state?.message} fingerType={state.fingerType === 'right'} /> :
                            <ImageListItem>
                                <img style={{ width: '100%', objectFit: "cover", maxHeight: "300px", border: '2px solid green', borderRadius: '5px', filter: 'invert(1)' }} src={RightFingerImage} alt="Right Finger" />
                            </ImageListItem>}
                        <ProceedBtn onClick={() => {
                            handleClick('right')
                        }}>
                            <Fingerprint />
                            <Typography sx={{ textTransform: "capitalize", fontSize: "14px" }}>Capture</Typography>
                        </ProceedBtn>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}

export default BiometricsForm;